import React, { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(process.env.GATSBY_MAIN_LANGUAGE);

  useEffect(() => {
    if (typeof window === "undefined") return;

    // 🔹 Detect language from URL path (e.g., /pl/product -> PL)
    const urlLang = window.location.pathname
      .split("/")
      .filter(Boolean)[0]
      ?.toUpperCase();
    const allowedLanguages = ["PL", "EN"];
    if (urlLang && allowedLanguages.includes(urlLang)) {
      localStorage.setItem("language", urlLang);
      setLanguage(urlLang);
      return;
    }

    const storedLang = localStorage.getItem("language");
    if (storedLang) {
      setLanguage(storedLang);
    } else {
      localStorage.setItem("language", process.env.GATSBY_MAIN_LANGUAGE);
    }
  }, []);

  const switchLanguage = (langCode) => {
    setLanguage(langCode);
    localStorage.setItem("language", langCode);
  };

  return (
    <LanguageContext.Provider value={{ language, switchLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
